import request from '@/utils/request'
const baseURL = '/anttalk-community'


// 查询社区公告列表
export function getCommunityNotice(params) {
  return request({
    url: '/CommunityNotice/v1/notices',
    method: 'get',
    baseURL,
    params
  })
}